import { Record } from 'immutable'

export class DriverSurchargeType extends Record({
    id: undefined,
    name: undefined,
    type: undefined,
    code: undefined,
}) {}
